<ws-stamp [dataValue]="parcel"
          [visible]="false"
          [activityStatusId]="parcel.activityStatusID"
          [transaction]="parcel.transaction">
</ws-stamp>
<div style="display: flex; justify-content: space-between;">
    <div style="flex: 1;">
        <div style="display: flex; gap: 10px; align-items: center;">
            <parcel-icon class="ws-display-inline-block"
                         [parcel]="parcel"
                         [isLinkedParcel]="!!parcel.masterParcelId || !!parcel.subParcelCount"
                         [isMasterParcel]="!parcel.masterParcelId && !!parcel.subParcelCount"
                         propTypeParam="propertyType.propTypeAbbr"
                         size="large"
                         [includeIcons]="true"
                         [ppReturnPreparationAllowed]="parcelViewDto.ppReturnPreparationAllowed"
                         [stateAllowConsolidating]="stateAllowConsolidating">
            </parcel-icon>
            <h3 ng-class="{'preserve-white-space': acctNumHasDoubleSpace}" style="margin: 0;">{{ parcel.acctNum }}</h3>
        </div>

        <table class="view-info-table">
            @for (acctNum of altAcctNums; track acctNum) {
                <tr>
                    <td>{{ acctNum.accountNumberType.accountNumberDesc }}:</td>
                    <td>{{ acctNum.acctNumber }}</td>
                </tr>
            }
            <tr>
                <td>Assessee:</td>
                <td>{{ parcel.assesseeName }}</td>
            </tr>
            <tr>
                <td>Desc:</td>
                <td>{{ parcel.description }}</td>
            </tr>
            <tr>
                <td>Address:</td>
                <td>
                    <address-view-edit [address]="address" [isEditMode]="false"></address-view-edit>
                </td>
            </tr>
            <tr>
                <td>Assessor:</td>
                <td>
                    <a anchor-route
                       helpTooltip
                       [contentComponent]="assessorDetailsRenderer"
                       [contentComponentValue]="parcelAssessor"
                       [sref]="{ target: 'assessor', options: { stateId: parcel.address.stateID, id: parcel.assessorID } }">
                        {{ parcelAssessor?.abbr }} {{ parcelAssessor?.municipalityName }}
                    </a>
                </td>
            </tr>
            @if (showTaxingDistrict) {
                <tr>
                    <td>Taxing District</td>
                    <td>{{ parcel.taxingDistrictModel?.displayName }}</td>
                </tr>
            }
            <tr>
                <td>Assessment Class(es):</td>
                <td>
                    @for (ac of parcel.parcelAssessmentClasses; track ac; let last = $last) {
                        <span>
                            {{ ac.assessmentClass.name }}@if (!last) {
                            <span>,</span>
                        }
                        </span>
                    }
                </td>
            </tr>
            <tr>
                <td>Collector(s):</td>
                <td>
                    @for (collector of parcel.parcelCollectors; track collector) {
                        <div>
                            <a anchor-route [sref]="getCollectorSref(collector)">
                                {{ collector.collectorAbbr }} @if (collector.collectorBillingScenarioName) {
                                <span>- {{ collector.collectorBillingScenarioName }}</span>
                            }
                            </a>
                            @if (collector.collectorAcctNum) {
                                <div>
                                    Collector Acct Num: {{ collector.collectorAcctNum }}
                                </div>
                            }
                            @for (option of collector.parcelCollectorPaymentOptions; track option) {
                                <div>
                                    @if (option.collectorPaymentOption.name) {
                                        <span>
                                            @if (option.collectorPaymentOption.collectorBillName) {
                                                <span>{{ option.collectorPaymentOption.collectorBillName }} </span>
                                            }Pmt Option: {{ option.collectorPaymentOption.name }}
                                        </span>
                                    }
                                </div>
                            }
                            <div>
                                <collector-tax-rate-area [trs]="getTRS(collector)"
                                                         [parcelCollector]="collector"
                                                         [parcel]="parcel"
                                                         [editMode]="false"
                                                         [years]="years">
                                </collector-tax-rate-area>
                            </div>
                        </div>
                    }
                </td>
            </tr>
            <tr>
                <td>Legal Desc:</td>
                <td>
                    {{ parcel.legalDescription?.substring(0, 50) }}
                    @if (parcel.legalDescription?.length > 50) {
                        <a (click)="showLegalDescriptionDialog()"
                           style="padding-left: 10px; cursor: pointer;">more...</a>
                    }
                </td>
            </tr>
            @if (parcel.accrualsEnabled) {
                @if (parcel.accrualsExclude.parentExcludedFromAccruals) {
                    <tr>
                        <td>Parent Excluded From Accruals</td>
                        <td></td>
                    </tr>
                }
                @if (!parcel.accrualsExclude.parentExcludedFromAccruals) {
                    <tr>
                        <td>Exclude From Accruals:</td>
                        <td>
                            <input type="checkbox"
                                   [(ngModel)]="parcel.accrualsExclude.excludeFromAccruals"
                                   [disabled]="true">
                        </td>
                    </tr>
                }
            }
            <tr>
                <td>
                    <linked-parcels [parcelId]="parcel.parcelID"
                                    [parcelAcctNum]="parcel.acctNum"
                                    [masterParcelId]="parcel.masterParcelId"
                                    [masterParcelAcctNum]="parcel.masterParcelAcctNum"
                                    [linkedParcelCount]="parcel.subParcelCount">
                    </linked-parcels>
                </td>
                <td></td>
            </tr>
        </table>
    </div>
    <div>
        <div>
            <entity-attachments buttonClass="has-icon btn-lg"
                                [isNestedModal]="false"
                                helpTooltip helpContentId="parcel-info-panel.attachments"
                                position="left"
                                [(hasAttachments)]="parcel.hasAttachments"
                                [modalData]="attachmentsModel">
            </entity-attachments>
        </div>
        @if (parcel.hasImages) {
            <div>
                <entity-attachments buttonClass="has-icon btn-lg"
                                    [isNestedModal]="false"
                                    helpTooltip
                                    helpContentId="parcel-info-panel.images"
                                    position="left"
                                    [forImages]="true"
                                    (hasImagesChange)="parcel.hasImages = $event"
                                    [modalData]="attachmentsModel">
                </entity-attachments>
            </div>
        }
        <div>
            <entity-comments [(hasComments)]="parcel.hasComments"
                             buttonClass="has-icon btn-lg"
                             helpTooltip
                             helpContentId="parcel-info-panel.comments"
                             position="left"
                             [modalData]="commentsModel">
            </entity-comments>
        </div>
        @if (optimusLinkInfo?.url) {
            <div>
                <a class="ace-btn has-icon btn-lg btn-primary"
                   href="{{optimusLinkInfo?.url}}" target="_blank"
                   helpTooltip helpContentId="parcel-info-panel.optimus" position="left">
                    <img src="/images/OptimusIconOnDark.png"
                         style="border: 0; vertical-align: middle; margin-top: 5px; max-height: 80%; max-width: 80%;" />
                </a>
            </div>
        }
    </div>
</div>
